import React from "react";
import { AlertTriangle } from "lucide-react";

export const DisclaimerAlert: React.FC = () => {
  return (
    <aside className="disclaimer-banner">
      <AlertTriangle size={20} style={{ flexShrink: 0 }} />
      <div>
        <strong style={{ fontWeight: 700 }}>Aviso Legal e Natureza das Estimativas:</strong> O{" "}
        <strong>Right Bid</strong> é uma plataforma puramente analítica e passiva de dados públicos. O
        sistema <strong>nunca envia propostas ou lances</strong> à Receita Federal. O{" "}
        <em>"Custo Unitário Estimado"</em> é uma aproximação matemática linear (Lance Mínimo do Lote ÷ Total de Unidades)
        voltada exclusivamente para priorização e triagem relativa, não configurando preço de mercado ou avaliação individual tabelada.
      </div>
    </aside>
  );
};
